import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { Paper } from '@shared/ui/common/paper';
import { InfoActionMessage } from '@shared/ui/common/InfoActionMessage';
import { WarehouseConnection } from '@domain/inventory/models/WarehouseConnection';
import { useWarehouseConnection } from '../../hooks/useWarehouseConnection';

import { FileWarehouseConnectionButton } from '../create/file/FileWarehouseConnectionButton';
import { DefaultWarehouseConnectionButton } from './DefaultWarehouseConnectionButton';
import { WarehouseConnectionType } from '@domain/inventory/enums/WarehouseConnectionType.enum';
import { ManualWarehouseConnectionButton } from './ManualWarehouseConnectionButton';

const WarehouseConnections = () => {
    const { id } = useParams<{ id: string }>();
    const { warehouseConnections } = useWarehouseConnection(id);


    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [editingConnection, setEditingConnection] = useState<WarehouseConnection | null>(null);

    const handleEditConnection = (connection: WarehouseConnection) => {
        setEditingConnection(connection);
        setIsDialogOpen(true);
    };

    return (
        <Paper>
            <DialogHeader>
                <Typography variant="body1">Connections</Typography>
            </DialogHeader>

            {warehouseConnections.length === 0 ? (
                <ManualWarehouseConnectionButton warehouseId={id!} />    
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {warehouseConnections.map((connection) =>
                        connection.sourceType === WarehouseConnectionType.FILE ? (
                            <FileWarehouseConnectionButton key={connection.id} connection={connection} onEditConnection={handleEditConnection} />
                        ) : (
                            <DefaultWarehouseConnectionButton key={connection.id} connection={connection} onEditConnection={handleEditConnection} />
                        )
                    )}
                </Box>
            )}
        </Paper>
    );
};

export default WarehouseConnections;